import axiosInstance from '../axiosInstance';

export const getActiveCoupons = async (page = 0) => {
  const response = await axiosInstance.get('/coupon', {
    params: { active: true, page, size: 5 },
  });
  return response.data.data;
};

export const getInactiveCoupons = async (page = 0) => {
  const response = await axiosInstance.get('/coupon', {
    params: { active: false, page, size: 5 },
  });
  return response.data.data;
};
